// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Clip from 'vue-clip'
import Vee from 'vee-validate'
// import runtime from 'serviceworker-webpack-plugin/lib/runtime'
import BaseMainMenu from './components/molecules/BaseMainMenu'
import './styles/base.sass'

// if ('serviceWorker' in navigator) {
//   const registration = runtime.register()
//   console.log(registration)
// }

/* COMPONENTS */
Vue.component('main-menu', BaseMainMenu)

Vue.use(Clip)
Vue.use(Vee)
const dict = {
  custom: {
    email: {
      required: 'Câmpul email este obligatoriu.',
      email: 'Formatul adresei email nu este valid (ex: a@a.aa)'
    },
    nume: {
      required: 'Câmpul nume este obligatoriu.'
    },
    prenume: {
      required: 'Câmpul prenume este obligatoriu.'
    },
    oras: {
      required: 'Câmpul oraș este obligatoriu.'
    },
    categorie: {
      required: 'Câmpul categorie este obligatoriu.'
    },
    anexe: {
      required: 'Câmpul anexe este obligatoriu.'
    },
    lucrare: {
      required: 'Câmpul lucrare este obligatoriu.'
    },
    varsta: {
      required: 'Câmpul varsta este obligatoriu.'
    },
    phone: {
      required: 'Câmpul telefon este obligatoriu.'
    },
    dece: {
      required: 'Câmpul este obligatoriu.'
    },
    descriere: {
      required: 'Câmpul descriere este obligatoriu.'
    },
    proiect: {
      required: 'Câmpul proiect este obligatoriu.'
    },
    tel: {
      required: 'Câmpul telefon este obligatoriu.'
    }
  }
}
Vee.Validator.localize('en', dict)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  created: function () {
    (function (d, s, id) {
      var js
      var fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s)
      js.id = id
      js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  },
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js